/*DF estimator loader*/function dfLoadEstimator(){document.querySelectorAll('script:not([data-df-run])').forEach(function(s){if(s.textContent.indexOf("querySelectorAll('[data-fc]')")<0)return;s.dataset.dfRun='1';var n=document.createElement('script');n.textContent=s.textContent;document.head.appendChild(n);n.remove()})}dfLoadEstimator();document.addEventListener('shopify:section:load',dfLoadEstimator);
function dfLoadEstimatorAsset(){document.querySelectorAll('script[data-df-asset]:not([data-df-loaded])').forEach(function(s){s.dataset.dfLoaded='1';var n=document.createElement('script');n.src=s.src;n.defer=true;document.head.appendChild(n)})}dfLoadEstimatorAsset();document.addEventListener('shopify:section:load',dfLoadEstimatorAsset);
(function(){document.querySelectorAll('[data-fc]').forEach(function(_y,_f){if(_y.dataset.ready==='true')return;_y.dataset.ready='true';var $m=_y.hasAttribute('data-cb');var _u=_y.querySelector('[data-h]');var _v=_y.querySelector('[data-l]');var _w=_y.querySelector('[data-pr]');var _x=_y.querySelector('[data-er]');var a0=_y.querySelector('[data-mi]');var $7=_y.querySelector('[data-pm]');var $d=_y.querySelector('[data-qpl]');var $k=Array.prototype.slice.call(_y.querySelectorAll('[data-gi]'));var $i=_y.querySelector('[data-gc]');var $p=0;var _g=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:0,maximumFractionDigits:2});if($m){var closeboardImages={3:'//cdn.shopify.com/s/files/1/0958/9948/4426/files/Rock-3ft_12.jpg?v=1786635306&width=1400',4:'//cdn.shopify.com/s/files/1/0958/9948/4426/files/Rock-4ft_12.jpg?v=1786635244&width=1400',5:'//cdn.shopify.com/s/files/1/0958/9948/4426/files/Rock-5ft_12.jpg?v=1786635160&width=1400',6:'//cdn.shopify.com/s/files/1/0958/9948/4426/files/Rock-6ft_12.jpg?v=1786635051&width=1400',66:'//cdn.shopify.com/s/files/1/0958/9948/4426/files/Rock-6.6ft_12.jpg?v=1786635380&width=1400'};var closeboardOptions=[['2ft 6in','2ft','6in',76,145,'4ft 6in',22,32,24,3],['3ft','2ft 6in','6in',77,150,'4ft 6in',22,32,24,3],['3ft','2ft','12in',78,150,'4ft 6in',22,32,24,3],['3ft 6in','3ft','6in',80.5,152.5,'5ft 9in',24.5,34,26,3],['3ft 6in','2ft 6in','12in',81.5,152.5,'5ft 9in',24.5,34,26,3],['4ft','3ft 6in','6in',81.5,155,'5ft 9in',24.5,34,26,4],['4ft','3ft','12in',82.5,155,'5ft 9in',24.5,34,26,4],['4ft 6in','4ft','6in',84.5,157.5,'6ft 9in',26.5,38,30,4],['4ft 6in','3ft 6in','12in',85.5,157.5,'6ft 9in',26.5,38,30,4],['5ft','4ft 6in','6in',87.45,160,'6ft 9in',26.5,38,30,5],['5ft','4ft','12in',86.5,160,'6ft 9in',26.5,38,30,5],['5ft 6in','5ft','6in',92.6,162.5,'7ft 9in',28.5,42,38,5],['5ft 6in','4ft 6in','12in',91.45,162.5,'7ft 9in',28.5,42,38,5],['6ft','5ft 6in','6in',95.75,165,'7ft 9in',28.5,42,38,6],['6ft','5ft','12in',94.6,165,'7ft 9in',28.5,42,38,6],['6ft 6in','6ft','6in',104.85,175,'9ft',35.5,52,45,66],['6ft 6in','5ft 6in','12in',104.75,175,'9ft',35.5,52,45,66],['7ft','6ft 6in','6in',109.05,180,'9ft',35.5,52,45,66],['7ft','6ft','12in',106.85,180,'9ft',35.5,52,45,66],['7ft 6in','7ft','6in',133.8,200,'10ft',55,66,58,66],['7ft 6in','6ft 6in','12in',130.55,200,'10ft',55,66,58,66],['8ft','7ft','12in',135.8,210,'10ft',55,66,58,66]];_u.innerHTML='';closeboardOptions.forEach(function(_U,_z){var _t=document.createElement('option');_t.value=String(_U[4]);_t.textContent=_U[0]+' total · '+_U[1]+' panel + '+_U[2]+' board';_t.dataset.w='1.83';_t.dataset.panel=_U[1];_t.dataset.board=_U[2];_t.dataset.supply=String(_U[3]);_t.dataset.installed=String(_U[4]);_t.dataset.post=_U[5];_t.dataset.intermediate=String(_U[6]);_t.dataset.corner=String(_U[7]);_t.dataset.end=String(_U[8]);_t.dataset.image=closeboardImages[_U[9]];_t.selected=_z===13;_u.appendChild(_t)})}function setSlide(nextIndex){if(!$k.length)return;$p=(nextIndex+$k.length)%$k.length;$k.forEach(function(_T,_z){var _P=_z===$p;_T.classList.toggle('is-a',_P);_T.setAttribute('aria-hidden',_P?'false':'true')});if($i)$i.textContent=String($p+1)}var _m=_y.querySelector('[data-gp]');var a1=_y.querySelector('[data-gn]');if(_m)_m.addEventListener('click',function(){setSlide($p-1)});if(a1)a1.addEventListener('click',function(){setSlide($p+1)});setSlide(0);function $K(_I){return _I.toFixed(2).replace(/\.?0+$/,'')}function $o(){return $7?$7.value:'installed'}function $a(_t){return parseFloat($o()==='supply'?_t.dataset.supply:_t.dataset.installed)}function update(){var _t=_u.options[_u.selectedIndex];var _q=parseFloat(_v.value);var _N=$m?$a(_t)/parseFloat(_t.dataset.w):parseFloat(_t.value);_x.textContent='';if(a0&&_t.dataset.image){a0.removeAttribute('srcset');a0.src=_t.dataset.image}if($d&&$m)$d.textContent='Quick straight-run '+($o()==='supply'?'supply-only':'installed')+' estimate';if(!_v.value){_w.textContent=$m?'£0':'Enter a length';return}if(!Number.isFinite(_q)||_q<=0){_w.textContent='—';_x.textContent='Please enter a length greater than 0.';return}if(_q<.5){_w.textContent='—';_x.textContent='Minimum estimate length is 0.5m.';return}if(_q>200){_w.textContent='Contact us';_x.textContent='For lengths over 200m, request a tailored quote.';return}_w.textContent=_g.format(_q*_N)}function setupExact(){var _C=_y.querySelector('[data-x]');if(!_C)return function(){};var _B=_C.querySelector('[data-rlist]');var _Z=_C.querySelector('[data-ar]');var $y=_C.querySelector('[data-xp]');var $e=_C.querySelector('[data-xpl]');var $q=_C.querySelector('[data-xs]');var $r=_C.querySelector('[data-xl]');var _k=_C.querySelector('[data-rb]');var $z=_C.querySelector('[data-xe]');var _l=_C.querySelector('[data-xu]');var $0=_C.querySelector('[data-xn]');var $C=0;var $A=_y.dataset.sl||'section';var $B=_y.dataset.sn||'fencing';var $D=null,_c=null,_mods=null;if($m){_l.hidden=true;$0.textContent='Each run rounds up to a full 1.83m section. Posts, corners, custom angles and new sections are itemised. Gates, removal, slopes, obstructions and unusual ground require a tailored quote.';var _j=document.createElement('div');_j.className='df-bp';_j.innerHTML='<label for="df-start-post-'+_f+'">First let\'s select the starting post</label><select id="df-start-post-'+_f+'" data-sp><option value="" selected disabled>Choose start post</option><option value="existing">Existing post in place</option><option value="end">Start with end post</option><option value="intermediate">Start with intermediate post</option><option value="wall-fixing">Wall fixing</option></select>';_B.parentNode.insertBefore(_j,_B);$D=_j.querySelector('[data-sp]');_Z.textContent='Add another run';_Z.classList.add('df-ract');_mods=document.createElement('div');_mods.className='df-site-modifiers';_mods.setAttribute('data-site-modifiers','');_mods.innerHTML='<fieldset class="df-site-group" aria-describedby="df-access-help-'+_f+'"><legend>Site access</legend><p class="df-site-help" id="df-access-help-'+_f+'">Choose the distance from vehicle access to the fence line.</p><div class="df-site-options"><div class="df-site-option"><input type="radio" id="df-access-good-'+_f+'" name="df-access-'+_f+'" value="0" data-label="Good access · 0–25m"><label for="df-access-good-'+_f+'"><span class="df-site-option-title">Good access · 0–25m</span></label></div><div class="df-site-option"><input type="radio" id="df-access-medium-'+_f+'" name="df-access-'+_f+'" value="0.075" data-label="Medium access · 26–50m"><label for="df-access-medium-'+_f+'"><span class="df-site-option-title">Medium access · 26–50m</span></label></div><div class="df-site-option"><input type="radio" id="df-access-poor-'+_f+'" name="df-access-'+_f+'" value="0.15" data-label="Poor access · 51m+"><label for="df-access-poor-'+_f+'"><span class="df-site-option-title">Poor access · 51m+</span></label></div></div></fieldset><fieldset class="df-site-group" aria-describedby="df-condition-help-'+_f+'"><legend>Site conditions</legend><p class="df-site-help" id="df-condition-help-'+_f+'">Choose how much clearance is needed before installation.</p><div class="df-site-options"><div class="df-site-option"><input type="radio" id="df-condition-ready-'+_f+'" name="df-condition-'+_f+'" value="0" data-label="Ready for fence"><label for="df-condition-ready-'+_f+'"><span class="df-site-option-title">Ready for fence</span></label></div><div class="df-site-option"><input type="radio" id="df-condition-some-'+_f+'" name="df-condition-'+_f+'" value="0.075" data-label="Some clearance needed"><label for="df-condition-some-'+_f+'"><span class="df-site-option-title">Some clearance needed</span></label></div><div class="df-site-option"><input type="radio" id="df-condition-lots-'+_f+'" name="df-condition-'+_f+'" value="0.15" data-label="Lots of clearance needed"><label for="df-condition-lots-'+_f+'"><span class="df-site-option-title">Lots of clearance needed</span></label></div></div></fieldset>';_Z.parentNode.insertBefore(_mods,_Z.nextSibling);_c=document.createElement('button');_c.type='button';_c.className='df-done';_c.textContent='Complete and view quote';_Z.parentNode.insertBefore(_c,_mods.nextSibling);$y.closest('.df-xr').hidden=true;_k.hidden=true;$0.hidden=true;[_B,_Z,_mods,_c].forEach(function(part){part.hidden=true});$D.addEventListener('change',function(){_B.hidden=false;_mods.hidden=$o()!=='installed';_c.hidden=false;$n()});Array.prototype.forEach.call(_mods.querySelectorAll('input'),function(input){input.addEventListener('change',$n)});_c.addEventListener('click',function(){var $E=_y.querySelector('[data-qp]');_C.open=false;_C.hidden=true;$E.hidden=false;$E.querySelector('[data-qn]').focus();$E.scrollIntoView({behavior:'smooth',block:'center'})})}else{_l.textContent=$B+' · supplied widths and installed rates change with the chosen height.'}function plural(_R){return $A+(_R===1?'':'s')}function $f(_i,_r,_Q){var _s=document.createElement('li');if(_Q)_s.className='df-be';_s.innerHTML='<span>'+_i+'</span><strong>'+(typeof _r==='number'?_g.format(_r):_r)+'</strong>';_k.appendChild(_s)}function $Z(_t){return _t.textContent.split(' total')[0]}function $L(_A,_z){var _D=_A.querySelector('[data-rt]'),ratio=_A.querySelector('[data-rq]');ratio.innerHTML='';Array.prototype.forEach.call(_u.options,function(_t,optionIndex){if($Z(_t)===_D.value){var _J=document.createElement('option');_J.value=optionIndex;_J.textContent=(_t.dataset.panel+' / '+_t.dataset.board).replace(/ft/g,'′').replace(/in/g,'″');ratio.appendChild(_J)}});if(_z!=null&&ratio.querySelector('option[value="'+_z+'"]'))ratio.value=_z}function $_(_A){var ratio=_A.querySelector('[data-rq]');if(ratio)return _u.options[parseInt(ratio.value,10)];var select=_A.querySelector('[data-rh]');return select.options[select.selectedIndex]}function populatedRows(_V){return _V.filter(function(_A){return Boolean(_A.querySelector('[data-rl]').value)})}function nextPopulatedRow(_V,_z){for(var n=_z+1;n<_V.length;n+=1){if(_V[n].querySelector('[data-rl]').value)return _V[n]}return null}function jointOption(_K,_L){if(!_L)return _K;var _n=$_(_L);return parseFloat(_n.dataset.corner)>parseFloat(_K.dataset.corner)?_n:_K}function boundaryPostPrice(_J,_t){if(_J==='end')return parseFloat(_t.dataset.end);if(_J==='intermediate')return parseFloat(_t.dataset.intermediate);if(_J==='wall-fixing')return 15;return 0}function boundaryPostName(_p,_J,_t){if(_J==='end')return _p+' with '+_t.dataset.post+' end post';if(_J==='intermediate')return _p+' with '+_t.dataset.post+' intermediate post';if(_J==='wall-fixing')return _p+' with wall fixing';return _p+' with existing post in place'}function $M(){Array.prototype.forEach.call(_B.querySelectorAll('[data-rf]'),function(_A,_z){var number=_z+1;var label=_A.querySelector('[data-rll]');var _M=_A.querySelector('[data-rl]');var remove=_A.querySelector('[data-rr]');label.textContent='Length '+number+' (m)';_M.setAttribute('aria-label','Fence length '+number);remove.setAttribute('aria-label','Remove fence length '+number)})}function addRun(){if(_B.children.length>=20)return;$C+=1;var _A=document.createElement('div');var $3='df-run-length-'+_f+'-'+$C;var $4='df-rh-'+_f+'-'+$C;var $5='df-run-ratio-'+_f+'-'+$C;var $6='df-ra-'+_f+'-'+$C;var angleId='df-angle-'+_f+'-'+$C;_A.className='df-rf'+($m?' df-cbr':'');_A.setAttribute('data-rf','');if($m){_A.innerHTML='<div><label data-rll for="'+$3+'">Length</label><div class="df-len"><input id="'+$3+'" data-rl type="number" inputmode="decimal" min="0.1" max="200" step="0.01" placeholder="e.g. 3"><span>metres</span></div></div><div><label for="'+$4+'">Total Height</label><select class="df-rh" id="'+$4+'" data-rt></select></div><div><label for="'+$5+'">Panel/Board Ratio</label><select class="df-rh" id="'+$5+'" data-rq></select></div><div><label for="'+$6+'">What\'s Next?</label><select class="df-ra" id="'+$6+'" data-ra><option value="" selected disabled>Choose next step</option><option value="left-90">Continue Run - 90° Left</option><option value="right-90">Continue Run - 90° Right</option><option value="straight">Continue Run - Straight</option><option value="custom-angle">Continue Run - Custom angle</option><option value="wall-fixing">End Run - Wall fixing</option><option value="end-end">End Run - End Post</option><option value="end-intermediate">End Run - Intermediate Post</option><option value="end-corner">End Run - Corner Post</option></select></div><div class="df-custom-angle" data-angle-wrap hidden><label for="'+angleId+'">Custom angle</label><div class="df-angle-input"><input id="'+angleId+'" data-angle type="number" inputmode="decimal" min="1" max="359" step="0.1" placeholder="e.g. 135"><span>degrees</span></div><small>Enter the angle between this run and the next. This is included as an installation instruction.</small></div><button class="df-rr" type="button" data-rr aria-label="Remove fence length">×</button>'}else{_A.innerHTML='<div><label data-rll for="'+$3+'">Length</label><div class="df-len"><input id="'+$3+'" data-rl type="number" inputmode="decimal" min="0.1" max="200" step="0.01" placeholder="e.g. 3"><span>metres</span></div></div><div><label for="'+$4+'">Height</label><select class="df-rh" id="'+$4+'" data-rh aria-label="Fence height for this length"></select></div><button class="df-rr" type="button" data-rr aria-label="Remove fence length">×</button>'}_A.querySelector('[data-rl]').addEventListener('input',$n);_A.querySelector('[data-rr]').addEventListener('click',function(){_A.remove();$M();_Z.disabled=false;$n()});if($m){var $Y=_A.querySelector('[data-rt]'),runRatio=_A.querySelector('[data-rq]'),seen={};Array.prototype.forEach.call(_u.options,function(_t){var name=$Z(_t);if(!seen[name]){seen[name]=true;var _J=document.createElement('option');_J.value=name;_J.textContent=name;$Y.appendChild(_J)}});$Y.value=$Z(_u.options[_u.selectedIndex]);$L(_A,_u.selectedIndex);$Y.dataset.followTop='true';$Y.addEventListener('change',function(){$Y.dataset.followTop='false';$L(_A);$n()});runRatio.addEventListener('change',function(){$Y.dataset.followTop='false';$n()});var angleSelect=_A.querySelector('[data-ra]'),angleWrap=_A.querySelector('[data-angle-wrap]'),angleInput=_A.querySelector('[data-angle]');angleSelect.addEventListener('change',function(){var custom=angleSelect.value==='custom-angle';angleWrap.hidden=!custom;if(!custom)angleInput.value='';$n()});angleInput.addEventListener('input',$n)}else{var $X=_A.querySelector('[data-rh]');Array.prototype.forEach.call(_u.options,function(_t){$X.appendChild(_t.cloneNode(true))});$X.selectedIndex=_u.selectedIndex;$X.dataset.followTop='true';$X.addEventListener('change',function(){$X.dataset.followTop='false';$n()})}_B.appendChild(_A);$M();_Z.disabled=_B.children.length>=20;$n()}function $n(){var _V=Array.prototype.slice.call(_B.querySelectorAll('[data-rf]'));if($m&&_mods)_mods.hidden=$o()!=='installed';if($m){var last=_V.length&&_V[_V.length-1],$W=last&&last.querySelector('[data-rl]'),$U=$W&&parseFloat($W.value),$V=last&&last.querySelector('[data-ra]').value;_Z.hidden=!$D.value||$W&&(!Number.isFinite($U)||$U<=0||$U>200||!$V)}var $T=populatedRows(_V);var $N=0,$O=0,$j=0,$P=0,_W=0,_X=false,$g='';_k.innerHTML='';if($e)$e.textContent='Section-by-section '+($o()==='supply'?'supply-only':'installed')+' price';_V.forEach(function(_A,_z){var _M=_A.querySelector('[data-rl]');if(!_M.value)return;var _q=parseFloat(_M.value);var _t=$_(_A);var _N=parseFloat(_t.value);var _O=parseFloat(_t.dataset.w);if(!Number.isFinite(_q)||_q<=0||_q>200||!Number.isFinite(_O)||_O<=0){_X=true;$g='Each length must be between 0.1m and 200m and have a valid height.';return}var $Q=$m?$a(_t):(parseFloat(_t.dataset.sectionPrice)||_O*_N);if(!Number.isFinite($Q)){_X=true;$g='The selected pricing option is unavailable.';return}var _d=Math.ceil((_q-0.000001)/_O);var rowCost=_d*$Q;_W+=1;$N+=_d;$O+=_q;$j+=_d*_O;$P+=rowCost;$f('Length '+(_z+1)+': '+$K(_q)+'m · '+_t.textContent,_d+' '+plural(_d)+' × '+_g.format($Q)+' = '+_g.format(rowCost),false);if($m){var _Y=_A.querySelector('[data-ra]').value;var _L=nextPopulatedRow(_V,_z);var continues=_Y==='left-90'||_Y==='right-90'||_Y==='straight'||_Y==='custom-angle';if(!_Y){_X=true;$g='Choose What\'s Next for each entered length.';return}if(continues&&!_L){_X=true;$g='Add the next length after a Continue Run selection.';return}if(_Y==='custom-angle'){var customAngleInput=_A.querySelector('[data-angle]'),customAngle=customAngleInput&&parseFloat(customAngleInput.value);if(!Number.isFinite(customAngle)||customAngle<1||customAngle>359){_X=true;$g='Enter a custom angle between 1° and 359°.';return}var intermediatePrice=parseFloat(_t.dataset.intermediate);if(!Number.isFinite(intermediatePrice)){_X=true;$g='The intermediate post price is unavailable.';return}$P+=intermediatePrice;$f('Continue run · custom angle '+$K(customAngle)+'° · extra '+_t.dataset.post+' intermediate post',intermediatePrice,true)}else if(_Y==='wall-fixing'){$P+=15;$f('End run · wall fixing',15,true)}else if(_Y==='left-90'||_Y==='right-90'){var $b=jointOption(_t,_L);var _a=parseFloat($b.dataset.corner)-parseFloat($b.dataset.intermediate);$P+=_a;$f((_Y==='left-90'?'90° left':'90° right')+' · upgrade to '+$b.dataset.post+' corner post',_a,true)}else if(_Y.indexOf('end-')===0){var _o=_Y.substring(4),$9=parseFloat(_t.dataset[_o]);$P+=$9;$f('End run · '+_t.dataset.post+' '+_o+' post',$9,true)}}});if($m&&$T.length){var $R=$_($T[0]);var $S=boundaryPostPrice($D.value,$R);$P+=$S;$f(boundaryPostName('Start',$D.value,$R),$S,true)}if($m&&$o()==='installed'&&$T.length&&!_X){var accessChoice=_mods&&_mods.querySelector('input[name="df-access-'+_f+'"]:checked');var conditionChoice=_mods&&_mods.querySelector('input[name="df-condition-'+_f+'"]:checked');if(!accessChoice||!conditionChoice){_X=true;$g='Choose both site access and site conditions.'}else{var basePrice=$P;var accessRate=parseFloat(accessChoice.value)||0;var conditionRate=parseFloat(conditionChoice.value)||0;var accessCharge=basePrice*accessRate;var conditionCharge=basePrice*conditionRate;$P+=accessCharge+conditionCharge;$f('Site access · '+accessChoice.dataset.label,accessCharge,true);$f('Site conditions · '+conditionChoice.dataset.label,conditionCharge,true)}}if($m){_w.textContent=_W?_g.format($P):'£0';_c.disabled=_X||!_W||!$V||($V.indexOf('end-')!==0&&$V!=='wall-fixing')}$z.textContent=_X?$g:'';if(_X){$y.textContent='—';$q.textContent='Check the entered layout';$r.textContent='';return}if(!_W){$y.textContent='Enter a length';$q.textContent='0 complete sections';$r.textContent='0m entered';return}$y.textContent=_g.format($P);$q.textContent=$N+' complete '+plural($N);$r.textContent=$K($O)+'m entered · '+$K($j)+'m supplied capacity'}_Z.addEventListener('click',addRun);for(var i=0;i<($m?1:3);i+=1)addRun();if($m)_u.addEventListener('change',function(){Array.prototype.forEach.call(_B.querySelectorAll('[data-rt]'),function($Y){if($Y.dataset.followTop==='true'){var _A=$Y.closest('[data-rf]');$Y.value=$Z(_u.options[_u.selectedIndex]);$L(_A,_u.selectedIndex)}})});return $n}var $n=setupExact();if($m){var $u=Array.prototype.slice.call(_y.querySelectorAll('[data-cm]'));var $w=_y.querySelector('[data-rp]');var $x=_y.querySelector('[data-x]');var $v=_y.querySelector('[data-rnp]');var $E=_y.querySelector('[data-qp]');var $F=_y.querySelector('#df-qf');var $G=_y.querySelector('[data-qe]');var quoteName=_y.querySelector('[data-qn]');var quotePhone=_y.querySelector('[data-qph]');var quoteAddress=_y.querySelector('[data-qad]');var $H=_y.querySelector('[data-qb]');var $I=_y.querySelector('[data-qt]');var $s=_y.querySelector('[data-qs]');var $J=_y.querySelector('iframe[name="df-qfr"]');var $2=false;$x.classList.add('df-me');$x.hidden=true;function $c(_E){var rough=_E==='rough';$w.hidden=!rough;$x.hidden=rough;$x.open=!rough;$v.hidden=!rough;$E.hidden=true;$s.textContent='';$u.forEach(function(_S){var _h=_S.getAttribute('data-cm')===_E;_S.classList.toggle('is-sel',_h);_S.setAttribute('aria-expanded',_h?'true':'false')});if(rough)update();else $n()}$u.forEach(function(_S){_S.addEventListener('click',function(){$c(_S.getAttribute('data-cm'))})});function quoteLetters(value){return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^A-Za-z]/g,'').toUpperCase()}function quoteReference(name,address,date){var nameParts=String(name||'').trim().split(/\s+/).filter(Boolean);var first=quoteLetters(nameParts[0]||'X');var last=quoteLetters(nameParts.length>1?nameParts[nameParts.length-1]:nameParts[0]||'X');var nameCode=(first.charAt(0)+(nameParts.length>1?last.charAt(0):(first.charAt(1)||'X'))+'XX').slice(0,2);var withoutPostcode=String(address||'').replace(/\b[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}\b/ig,' ');var locationParts=withoutPostcode.split(',').map(function(part){return part.trim()}).filter(Boolean);var location;if(locationParts.length){location=locationParts[locationParts.length-1]}else{var locationWords=withoutPostcode.match(/[A-Za-z]+/g)||[];location=locationWords.length?locationWords[locationWords.length-1]:withoutPostcode}var locationCode=(quoteLetters(location)+'XX').slice(0,2);return nameCode+String(date.getDate()).padStart(2,'0')+String(date.getMonth()+1).padStart(2,'0')+locationCode}function quoteFeet(metres){var totalInches=Math.round(metres*39.3700787402);var feet=Math.floor(totalInches/12),inches=totalInches%12;return feet+'ft'+(inches?' '+inches+'in':'')}function quoteStartDescription(index,rows,startSelect){if(index===0){var startValue=startSelect?startSelect.value:'';if(startValue==='existing')return'Start with existing post in place';if(startValue==='end')return'Start with end post';if(startValue==='intermediate')return'Start with intermediate post';if(startValue==='wall-fixing')return'Start with wall fixing';return'Start point not selected'}var previousAction=rows[index-1].querySelector('[data-ra]').value;if(previousAction==='left-90'||previousAction==='right-90'||previousAction==='end-corner')return'Start with corner post';if(previousAction==='end-end')return'Start with end post';if(previousAction==='wall-fixing')return'Start with wall fixing';return'Start with intermediate post'}function quoteEndDescription(row){var action=row.querySelector('[data-ra]').value;if(action==='left-90')return'Finish with corner post · 90° left angle';if(action==='right-90')return'Finish with corner post · 90° right angle';if(action==='straight')return'Finish with intermediate post · continue straight';if(action==='custom-angle'){var angle=parseFloat(row.querySelector('[data-angle]').value);return'Finish with intermediate post · custom angle '+$K(angle)+'°'}if(action==='end-end')return'Finish with end post';if(action==='end-intermediate')return'Finish with intermediate post';if(action==='end-corner')return'Finish with corner post';if(action==='wall-fixing')return'Finish with wall fixing';return'Finish point not selected'}function $1(){var quoteList=_y.querySelector('[data-rlist]'),startSelect=_y.querySelector('[data-sp]'),siteModifiers=_y.querySelector('[data-site-modifiers]'),rows=Array.prototype.slice.call(quoteList?quoteList.querySelectorAll('[data-rf]'):[]).filter(function(row){return Boolean(row.querySelector('[data-rl]').value)}),summaries=[],baseTotal=0;function quoteOption(row){var ratio=row.querySelector('[data-rq]');if(ratio)return _u.options[parseInt(ratio.value,10)];var select=row.querySelector('[data-rh]');return select.options[select.selectedIndex]}function nextQuoteRow(index){for(var n=index+1;n<rows.length;n+=1){if(rows[n].querySelector('[data-rl]').value)return rows[n]}return null}function startPrice(kind,option){if(kind==='end')return parseFloat(option.dataset.end);if(kind==='intermediate')return parseFloat(option.dataset.intermediate);if(kind==='wall-fixing')return 15;return 0}rows.forEach(function(row,index){var length=parseFloat(row.querySelector('[data-rl]').value),option=quoteOption(row),width=parseFloat(option.dataset.w),sections=Math.ceil((length-0.000001)/width),sectionPrice=$a(option),subtotal=sections*sectionPrice,action=row.querySelector('[data-ra]').value;if(index===0)subtotal+=startPrice(startSelect?startSelect.value:'',option);if(action==='left-90'||action==='right-90'){var nextRow=nextQuoteRow(index);if(nextRow){var nextOption=quoteOption(nextRow),joint=parseFloat(nextOption.dataset.corner)>parseFloat(option.dataset.corner)?nextOption:option;subtotal+=parseFloat(joint.dataset.corner)-parseFloat(joint.dataset.intermediate)}}else if(action==='custom-angle'){subtotal+=parseFloat(option.dataset.intermediate)}else if(action==='wall-fixing'){subtotal+=15}else if(action.indexOf('end-')===0){subtotal+=parseFloat(option.dataset[action.substring(4)])}summaries.push({row:row,length:length,height:option.textContent.split(' total')[0],subtotal:subtotal});baseTotal+=subtotal});var accessChoice=null,conditionChoice=null,multiplier=1;if($o()==='installed'){accessChoice=siteModifiers&&siteModifiers.querySelector('input[name^=df-access-]:checked');conditionChoice=siteModifiers&&siteModifiers.querySelector('input[name^=df-condition-]:checked');multiplier+=accessChoice?(parseFloat(accessChoice.value)||0):0;multiplier+=conditionChoice?(parseFloat(conditionChoice.value)||0):0}var totalCents=Math.round(baseTotal*multiplier*100),allocated=0,quoteMoney=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:2,maximumFractionDigits:2});var lines=summaries.map(function(item,index){var cents=index===summaries.length-1?totalCents-allocated:Math.round(item.subtotal*multiplier*100);allocated+=cents;return'Length '+(index+1)+': '+quoteStartDescription(index,rows,startSelect)+' — '+$K(item.length)+'m ('+quoteFeet(item.length)+') length total at '+item.height+' high — '+quoteEndDescription(item.row)+' — Cost '+quoteMoney.format(cents/100)});if(accessChoice||conditionChoice){var instructions=[];if(accessChoice)instructions.push('Access: '+accessChoice.dataset.label);if(conditionChoice)instructions.push('Conditions: '+conditionChoice.dataset.label);lines.push('Site instructions: '+instructions.join(' · '))}return lines}function _b(_I){var element=document.createElement('div');element.textContent=String(_I);return element.innerHTML}function $l(_G,_F,_D,_e,_H,customerName,customerPhone,customerAddress){var _V=_F.map(function(_s){return'<li>'+_b(_s)+'</li>'}).join('');var quoteHtml='<!doctype html><html><head><meta charset="utf-8"><title>'+_b(_e)+' · Discount Fencing quote</title><meta name="viewport" content="width=device-width,initial-scale=1"><style>body{margin:0;background:#e8eaed;color:#1c1c1c;font:14px/1.45 Arial,sans-serif}.toolbar{position:sticky;top:0;z-index:5;display:flex;justify-content:center;gap:10px;padding:10px;background:#202124}#df-close-quote{background:#5f6368}.toolbar button{width:auto;min-width:220px;max-width:320px;padding:10px 18px;border:0;border-radius:7px;background:#2f7d32;color:#fff;font-size:14px;font-weight:700;cursor:pointer}.sheet{box-sizing:border-box;width:794px;max-width:calc(100% - 32px);min-height:1123px;margin:20px auto;padding:56px;background:#fff;box-shadow:0 4px 20px rgba(0,0,0,.16)}header{border-bottom:4px solid #e1ae22;padding-bottom:14px}h1{margin:0 0 6px;color:#865e00;font-size:24px;line-height:1.15}h2{font-size:18px;margin-top:20px}dl{display:grid;grid-template-columns:max-content 1fr;gap:5px 16px}dt{font-weight:700}dd{margin:0}li{margin:0 0 8px}.total{margin:20px 0;padding:16px;background:#e1ae22;font-size:22px;font-weight:800}@page{size:A4;margin:14mm}@media(max-width:700px){body{background:#fff}.toolbar{padding:8px}.toolbar button{width:auto;min-width:0;max-width:none}.sheet{width:100%;max-width:none;min-height:auto;margin:0;padding:22px 16px;box-shadow:none}dl{grid-template-columns:1fr;gap:2px}dd{margin:0 0 8px}.total{font-size:20px}}@media print{body{background:#fff}.toolbar{display:none}.sheet{width:auto;max-width:none;min-height:0;margin:0;padding:0;box-shadow:none}}</style></head><body><div class="toolbar"><button type="button" id="df-print-quote">Download / save PDF</button><button type="button" id="df-close-quote">Close</button></div><main class="sheet"><header><h1>Discount Fencing</h1><strong>Closeboard fencing estimate</strong></header><dl><dt>Quote reference</dt><dd>'+_b(_e)+'</dd><dt>Date</dt><dd>'+_b(_H)+'</dd><dt>Full name</dt><dd>'+_b(customerName)+'</dd><dt>Contact number</dt><dd>'+_b(customerPhone)+'</dd><dt>Address</dt><dd>'+_b(customerAddress).replace(/\n/g,'<br>')+'</dd><dt>Email</dt><dd>'+_b(_G)+'</dd><dt>Pricing option</dt><dd>'+_b($o()==='supply'?'Supply only':'Installed')+'</dd></dl><h2>Itemised fence layout</h2><ul>'+_V+'</ul><div class="total">Estimated total: '+_b(_D)+'</div><p>All prices exclude VAT. The final price is subject to confirmation of measurements, the selected access and site conditions, and any unlisted work.</p></main>\n</body></html>';var oldViewer=document.getElementById('df-quote-viewer');if(oldViewer&&oldViewer.parentNode){oldViewer.parentNode.removeChild(oldViewer);document.body.style.overflow=''}var previousOverflow=document.body.style.overflow;var viewer=null;try{viewer=document.createElement('div');viewer.id='df-quote-viewer';viewer.setAttribute('role','dialog');viewer.setAttribute('aria-modal','true');viewer.setAttribute('aria-label','Quote preview');viewer.style.cssText='position:fixed;inset:0;z-index:2147483647;background:#e8eaed';var quoteFrame=document.createElement('iframe');quoteFrame.title='Quote preview';quoteFrame.style.cssText='width:100%;height:100%;border:0;background:#fff';viewer.appendChild(quoteFrame);document.body.appendChild(viewer);document.body.style.overflow='hidden';var quoteDocument=quoteFrame.contentDocument||quoteFrame.contentWindow.document;quoteDocument.open();quoteDocument.write(quoteHtml);quoteDocument.close();var escapeQuote;var closeQuote=function(){document.body.style.overflow=previousOverflow;document.removeEventListener('keydown',escapeQuote);quoteDocument.removeEventListener('keydown',escapeQuote);if(viewer&&viewer.parentNode)viewer.parentNode.removeChild(viewer)};escapeQuote=function(event){if(event.key==='Escape')closeQuote()};document.addEventListener('keydown',escapeQuote);quoteDocument.addEventListener('keydown',escapeQuote);var closeButton=quoteDocument.getElementById('df-close-quote');if(closeButton)closeButton.addEventListener('click',closeQuote);var printButton=quoteDocument.getElementById('df-print-quote');if(printButton)printButton.addEventListener('click',function(){quoteDocument.documentElement.setAttribute('data-print-requested','true');quoteFrame.contentWindow.focus();quoteFrame.contentWindow.print()});quoteDocument.documentElement.setAttribute('data-quote-ready','true');return true}catch(error){document.body.style.overflow=previousOverflow;if(viewer&&viewer.parentNode)viewer.parentNode.removeChild(viewer);return false}}var quoteSubmitButton=$F.querySelector('button[type="submit"]');var sendAndShowQuote=function(event){if(event)event.preventDefault();if(!$F.reportValidity()){$s.textContent='Please complete all contact fields before opening your quote.';return false}try{var now=new Date(),_H=now.toLocaleString('en-GB',{dateStyle:'long',timeStyle:'short'}),_D=_w.textContent,_G=$G.value.trim(),customerName=quoteName.value.trim(),customerPhone=quotePhone.value.trim(),customerAddress=quoteAddress.value.trim(),_e=quoteReference(customerName,customerAddress,now),_F=$1();$I.value=_D;$H.value=['Closeboard fencing estimator quote',_e,_H,'Customer name: '+customerName,'Customer phone: '+customerPhone,'Customer address: '+customerAddress,'Customer email: '+_G,'Pricing option: '+($o()==='supply'?'Supply only':'Installed'),'Estimated total: '+_D,'','Itemised fence layout:'].concat(_F,['','All prices exclude VAT. Final price subject to confirmation of measurements, the selected access and site conditions, and any unlisted work.']).join('\n');var viewerOpened=$l(_G,_F,_D,_e,_H,customerName,customerPhone,customerAddress);$2=true;if(quoteSubmitButton)quoteSubmitButton.disabled=true;$s.textContent=viewerOpened?'Sending your quote… Your printable quote is open.':'The quote email is sending, but the printable preview could not open. Please try again.';HTMLFormElement.prototype.submit.call($F)}catch(error){$2=false;if(quoteSubmitButton)quoteSubmitButton.disabled=false;$s.textContent='We could not open your quote. Please try again.'}return false};if(quoteSubmitButton)quoteSubmitButton.addEventListener('click',sendAndShowQuote);$F.addEventListener('submit',sendAndShowQuote);$J.addEventListener('load',function(){if($2){$2=false;if(quoteSubmitButton)quoteSubmitButton.disabled=false;$s.textContent='Quote sent. Your printable quote is open.'}})}_u.addEventListener('change',function(){Array.prototype.forEach.call(_y.querySelectorAll('[data-rh]'),function($X){if($X.dataset.followTop==='true')$X.selectedIndex=_u.selectedIndex});update();$n();setSlide(0)});if($7)$7.addEventListener('change',function(){update();$n()});_v.addEventListener('input',update);update();$n()})})();
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      this.dispatchProductSelectEvent();

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  getAllSelectedOptions() {
    const options = [];
    this.querySelectorAll('fieldset, .product-form__input--dropdown').forEach((group) => {
      const checked = group.querySelector('input:checked') || group.querySelector('select option[selected]');
      if (checked) {
        options.push({ name: checked.dataset.optionName || '', value: checked.value });
      }
    });
    return options;
  }

  dispatchProductSelectEvent() {
    const { ProductSelectEvent } = window.StandardEvents || {};
    if (!ProductSelectEvent) return;

    const deferred = ProductSelectEvent.createPromise();
    this.pendingSelectPromise = deferred;

    this.dispatchEvent(
      new ProductSelectEvent({
        product: {
          id: this.dataset.productId,
          title: this.dataset.productTitle,
          handle: this.dataset.productHandle,
        },
        selectedOptions: this.getAllSelectedOptions(),
        promise: deferred.promise,
      })
    );
  }

  takePendingSelectPromise() {
    const deferred = this.pendingSelectPromise;
    this.pendingSelectPromise = null;
    return deferred;
  }

  resolvePendingSelectPromise(variant, sourceVariantSelects = this) {
    const deferred = this.takePendingSelectPromise();
    if (!deferred) return;

    if (variant) {
      deferred.resolve({
        variant: {
          id: variant.id,
          title: variant.title,
          availableForSale: variant.available,
          price: {
            amount: sourceVariantSelects?.dataset.selectedPriceAmount,
            currencyCode: sourceVariantSelects?.dataset.currencyCode,
          },
          selectedOptions: this.getAllSelectedOptions(),
        },
      });
    } else {
      deferred.resolve({ variant: null });
    }
  }

  rejectPendingSelectPromise(error) {
    this.takePendingSelectPromise()?.reject(error);
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  getCartQuantityForLine(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    return parseInt(input?.dataset.cartQuantity || input?.getAttribute('value') || '0', 10) || 0;
  }

  startCartLinesUpdate(items) {
    const { CartLinesUpdateEvent } = window.StandardEvents || {};
    if (!CartLinesUpdateEvent) return;

    const linesByAction = Object.entries(items).reduce((groups, [variantId, quantity]) => {
      const nextQuantity = parseInt(quantity, 10);
      const currentQuantity = this.getCartQuantityForLine(variantId);

      if (Number.isNaN(nextQuantity) || currentQuantity === nextQuantity) return groups;

      const action = currentQuantity === 0 ? 'add' : nextQuantity === 0 ? 'remove' : 'update';
      let line;
      if (action === 'add') {
        line = { merchandiseId: variantId, quantity: nextQuantity };
      } else {
        const lineKey = this.querySelector(`[data-quantity-variant-id="${variantId}"]`)?.dataset.quantityLineKey;
        // No AJAX line key on the row — likely cached HTML rendered before this
        // attribute landed. Skip rather than emit an event with id: ''.
        if (!lineKey) return groups;
        line = { id: lineKey, quantity: nextQuantity };
      }

      if (!groups[action]) groups[action] = [];
      groups[action].push(line);
      return groups;
    }, {});

    const deferreds = Object.entries(linesByAction).map(([action, lines]) => {
      const deferred = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action,
          context: 'product',
          lines,
          promise: deferred.promise,
        })
      );
      return deferred;
    });

    return {
      resolve: (parsedState) => {
        const payload = { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(parsedState) };
        deferreds.forEach((deferred) => deferred.resolve(payload));
      },
      reject: (error) => {
        deferreds.forEach((deferred) => deferred.reject(error));
      },
    };
  }

  dispatchCartErrorEvent(message, code) {
    const { CartErrorEvent } = window.StandardEvents || {};
    if (!CartErrorEvent) return;

    this.dispatchEvent(new CartErrorEvent({ error: message, code }));
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

/*DF estimator loader*/function dfLoadEstimator(){document.querySelectorAll('script:not([data-df-run])').forEach(function(s){if(s.textContent.indexOf("querySelectorAll('[data-fc]')")<0)return;s.dataset.dfRun='1';var n=document.createElement('script');n.textContent=s.textContent;document.head.appendChild(n);n.remove()})}dfLoadEstimator();document.addEventListener('shopify:section:load',dfLoadEstimator);
class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}
